import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CustomLayoutContext } from '@/layouts/provider';

function LayoutController(props) {
  const { menuDisplay, headerDisplay, setLayout, setMatch } = useContext(CustomLayoutContext);
  useEffect(() => {
    setMatch(props.match);
    if (props.menu !== menuDisplay || props.header !== headerDisplay) {
      setLayout({ menuDisplay: props.menu, headerDisplay: props.header });
    }
  }, []);

  return <div className="layout-controller">{props.children}</div>;
}

LayoutController.propTypes = {
  menu: PropTypes.bool.isRequired,
  header: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
};

LayoutController.defaultProps = {
  menu: true,
  header: true,
};

export default LayoutController;
